export const bodyTypes = {
  1: "Endomorph",
  2: "Mesomorph",
  3: "Ectomorph"
};
export const energyLevels = {
  1: "Regular",
  2: "High",
  3: "Low",
  4: "Fatigued"
};
export const lifeStyles = {
  1: "Parent",
  2: "Working Student",
  3: "Pregnant",
  3: "Other"
};
export const fitnessLevels = {
  1: "Beginner",
  2: "Intermediate",
  3: "Advanced"
};
export const goals = {
  1: "Lose Weight",
  2: "Gain Muscle Mass",
  3: "Maintain Physique",
  3: "Tone"
};
